import request from '../utils/request';
// url 比后台实际的RequestMapping多一个前缀 (此处多一个adaptation)
// 此处多写一个前缀，是因为后台gateway模块拦截到请求会自动截掉第一个前缀
export default {
    // 用户管理，获取所有的用户
    getAllUser(params) {
        return request({
            url: `/member/member/getAllUser`,
            method: 'get',
            params
        })
    },
    // 用户管理，删除某个用户
    deleteById(id) {
        return request({
            url: `/member/member/deleteUserById?id=${id}`,
            method: 'get'
        })
    },
    // 用户管理，添加用户
    addUser(data, ids) {
        return request({
            url: `/member/member/add/${ids}`,
            method: 'post',
            data
        })
    },
    // 用户管理，更新用户
    updateUser(data, ids) {
        return request({
            url: `/member/member/update/${ids}`,
            method: 'put',
            data
        })
    },
    // 获取门类
    getCategory() {
        return request({
            url: `/adaptation/adaptation/open/getCategory`,
            method: 'get'
        })
    },
    // 获取专业类
    getProfessionClassByCode(code) {
        return request({
            url: `/adaptation/adaptation/open/getProfessionClassByCode?code=${code}`,
            method: 'get'
        })
    },
    // 获取专业信息
    getProfessionInfoByCode(code) {
        return request({
            url: `/adaptation/adaptation/open/getProfessionInfoByCode?professionClassCode=${code}`,
            method: 'get'
        })
    },
    // 获取专业详情
    getProfessionDetailByCode(id) {
        return request({
            url: `/adaptation/adaptation/open/getProfessionDetail/${id}`,
            method: 'get',
        })
    },
    // 获取所有开设该专业院校
    getOpenCollegeDetailByCode(params) {
        return request({
            url: `/adaptation/adaptation/open/getOpenCollegeDetail`,
            method: 'get',
            params: params
        })
    },
    // 霍兰德测评结果
    submitHldTest(data) {
        return request({
            url: `/adaptation/adaptation/submit/`,
            method: 'post',
            data
        })
    },
    // 获取所有霍兰德题目
    getAllQuestion() {
        return request({
            url: `/adaptation/adaptation/ques/`,
            method: 'get',
        })
    },
    // 子系统维护，获取所有的专业
    getAllMajor(current, size) {
        return request({
            url: `/adaptation/adaptation/getAllMajor`,
            params: {
                current: current,
                size: size,
            },
            method: 'get',
        })
    },
    // 子系统维护，模糊查询专业名
    getMajorCondition(current, size, name) {
        return request({
            url: `/adaptation/adaptation/getMajor`,
            params: {
                current: current,
                size: size,
                name: name
            },
            method: 'get',
        })
    },
    // 子系统维护，删除专业
    deleteMajorByzydm(zydm) {
        return request({
            url: `/adaptation/adaptation/deleteMajorByzydm`,
            params: {
                zydm: zydm
            },
            method: 'get',
        })
    },
    // 子系统维护，添加专业
    addMajor(data) {
        return request({
            url: `/adaptation/adaptation/addMajor`,
            method: 'post',
            data
        })
    },
    // 子系统维护，修改专业
    updateMajor(data) {
        return request({
            url: `/adaptation/adaptation/updateMajor`,
            method: 'put',
            data
        })
    },
    // 获取查询专业
    getMajor(params) {
        return request({
            url: `/adaptation/adaptation/getMajor`,
            method: 'get',
            params
        })
    },
    // 获取门类
    getMajorML() {
        return request({
            url: `/adaptation/adaptation/getCate`,
            method: 'get',
        })
    },
    // 获取专业类
    getMajorProfessional(params) {
        return request({
            url: `/adaptation/adaptation/getProCate`,
            method: 'get',
            params
        })
    },
    // 获取所有的角色
    getAllRole(params) {
        return request({
            url: `/member/member/getAllRole`,
            method: 'get',
            params
        })
    },
    // 增加角色接口
    addRole(data) {
        return request({
            url: `/member/member/addRole`,
            method: 'post',
            data
        })
    },
    // 删除角色接口
    deleteRoleById(params) {
        return request({
            url: `/member/member/deleteRoleById`,
            method: 'get',
            params
        })
    },
    // 更新角色接口
    updateRole(data) {
        return request({
            url: `/member/member/updateRole`,
            method: 'put',
            data
        })
    },



}